import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectRapportDetails } from 'src/app/shared/model/object';

@Component({
  selector: 'app-status-overzicht-object',
  templateUrl: './status-overzicht-object.component.html',
  styleUrls: ['./status-overzicht-object.component.less']
})
export class StatusOverzichtObjectComponent implements OnInit {


  public currentDate = new Date();
  public objectid:number;
  public data : any;
  public object: ObjectRapportDetails = {
    Relatie : "",
    Contactpersoon : "",
    FaktuurDatum : "Factuur Datum",
    FaktuurNummer : "FactuurNummer",
    TotaalBedragEuro : null,
    ObjectNr : "",
    Object : ""
  }

  constructor( 
    private activatedRoute: ActivatedRoute,
    private objectService: ObjectenService 
    ) {

  }

  ngOnInit(): void {
    this.objectid = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.objectService.getStatusRapportObject(this.objectid).subscribe(data => {
        this.data = data;
    })
    this.objectService.getStatusRapportObjectDetails(this.objectid).subscribe(obj => {
      this.object = obj;
    })
  }

  print() {
    window.print()
  }


  formatNumber(data: any): string {
    return Number(data).toLocaleString("nl-NL", {minimumFractionDigits: 2})
  }

  getTotaal()  {
    let totaal = 0;
    if (!this.data) return ""
    this.data.forEach(element => {
      totaal = totaal + (element.KostenEuro * 1)
    });
    return this.formatNumber(totaal);
  }

}
